
import '~/js/views/general/includes/scroll-below';
import 'slick-carousel';

const $barsSlider = $('.js-drink-bars-slider');
const $barsSliderControls = $barsSlider.parent().find('.js-slider-controls');

$barsSlider.on('init reInit afterChange', (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    $barsSliderControls.find('.counter').text(`${i}/${slick.slideCount}`);
});

$barsSlider.slick({
    lazyLoad: 'progressive',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    appendArrows: $barsSliderControls,
    prevArrow: '<span class="prev arrow"><i class="ic ic-button-arrow-prev"></i></span>',
    nextArrow: '<span class="next arrow"><i class="ic ic-button-arrow-next"></i></span>'
});
